import api from "../service/alvara.service";
import * as types from "./alvara.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import alvaraActions from "./alvara.actions";
import sessionStorageUtils from "@common/helpers/sessionStorage.utils";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.ALVARA_IMPRIMIR, imprimir);
  yield takeEvery(types.ALVARA_VALIDAR, validaAlvara);
  yield takeEvery(types.ALVARA_GET, getAlvara);
}

function* imprimir(action) {
  const {payload} = action;
  const {data, isImprimirDireto} = payload;

  yield call(api.validarImprimirAlvara, data);
  const result = yield call(api.imprimirAlvara, data);

    if (result.data.Success) {
      const destino = isImprimirDireto ? "_self" : "_blank";
      window.open(result.data.Url, destino);
    }
    else{
      _alert.error(result.data.Error);
    }
}

function* validaAlvara(action) {
  const { payload } = action;
  yield call(api.validarAlvara, payload);
  sessionStorageUtils.setItem('alvara', payload);
  yield put(formActions.redirect("obrasParticulares.visualizarAlvara"));
}

function* getAlvara(action) {
  const { payload } = action;
  const result = yield call(api.getAlvara, payload);
  if (result != null) {
    yield put(alvaraActions.setAlvara(result.data));
  }
}
